export default "__VITE_ASSET__LERajz92__"